import jsonData from '../signals/jsonData';
import appState from '../signals/appState';
import mergeDuplicateProducts from '../tools/mergeDuplicateProducts';
import { exhibitorKeyOf, productsOfExhibitor } from '../tools/boothExhibitors';

const setLanguage = (languageCode) => {
	if (!languageCode) return;

	fetch(`./data-${languageCode}.json`)
		.then((response) => response.json())
		.then((data) => {
			console.log('language data', data);
			const localData = JSON.parse(localStorage.getItem('data'));

			jsonData.value = {
				...jsonData.value,
				currentLanguage: data.currentLanguage,
				basicInfo: {
					...jsonData.value.basicInfo,
					name: data.basicInfo.name,
					intro: data.basicInfo.intro,
					link: data.basicInfo.link,
				},
				floorInfo: jsonData.value.floorInfo.map((floor, index) => {
					return {
						...floor,
						name: data.floorInfo[index]?.name,
						map: data.floorInfo[index]?.map,
						sections: floor.sections?.map((section, sectionIndex) => {
							return {
								...section,
								name: data.floorInfo[index]?.sections[sectionIndex]?.name,
							};
						}),
					};
				}),
				exhibitorInfo: data.exhibitorInfo.map((exhibitor) => {
					// 一個產品掛多個分類時，資料上是複製成多列（一列一條分類路徑），
					// 所以這裡要先併回一筆，否則同一個產品會在清單、搜尋結果與彈窗裡各出現好幾次。
					// 併的時候分類路徑會全部保留，見 mergeDuplicateProducts 的說明。
					// 掛在這裡是因為全站的產品都是從這一行長出來的（exhibitor.products），
					// 在各個畫面各自去重一定會漏，而漏掉不會報錯。
					// 同一個攤位號碼有多家時，產品靠廠商名稱分給各家；單獨一家的攤位照舊只看號碼。
					const products = mergeDuplicateProducts(productsOfExhibitor(data.productInfo, data.exhibitorInfo, exhibitor));

					let favourite = false;

					if (localData && Array.isArray(localData.favouriteExhibitors)) {
						// 收藏認序號；舊版存的是攤位號碼，一併認得，訪客不用重新收藏一次。
						const 收藏 = localData.favouriteExhibitors;
						favourite = 收藏.includes(exhibitorKeyOf(exhibitor)) || 收藏.includes(exhibitor['攤位號碼']);
					}

					return {
						...exhibitor,
						products,
						favourite,
					};
				}),
				productInfo: data.productInfo,
				navigationInfo: data.navigationInfo,
				recommendedRoutes: data.recommendedRoutes || [],
			};

			appState.value = {
				...appState.value,
				loading: false,
			};
		})
		.catch(() => {
			console.log('匯入語言資料錯誤');
		});
};

export default setLanguage;
